import InputDecorator from '@enerex/unified-ui-react/form/InputDecorator';
import RadioGroup from '@enerex/unified-ui-react/form/RadioGroup';

const OPTIONS = [{ value: 'unset', label: 'Not set' }, { value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }];
const LookupNullableBoolean = ({ field, control, disabled }) => <InputDecorator name={field.name} control={control} label={field.label}
    render={({ field: input }) => <RadioGroup name={input.name} aria-label={field.label} options={OPTIONS} inline disabled={disabled}
        value={input.value === true ? 'yes' : input.value === false ? 'no' : 'unset'}
        onChange={value => input.onChange(value === 'unset' ? null : value === 'yes')} onBlur={input.onBlur} />} />;
export default LookupNullableBoolean;
